<template>
  <div class="column inline-flex">
    <!-- Menu Button -->
    <button class="z-150" @click="toggleMenu">
      <img
        src="@/assets/images/base/icons/hamburger.svg"
        class="transition-ease-in-out hover:opacity-70"
        loading="lazy"
      />
    </button>

    <!-- Dropdown Menu -->
    <transition
      name="fade"
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="isMenuOpen"
        class="z-140 absolute -left-2 top-8 mt-5 h-[calc(100vh-150px)] w-screen overflow-auto bg-white shadow-medium focus:outline-none focus:ring-0 xs:-left-5 md:-left-6"
      >
        <div class="col flex w-full">
          <a
            v-if="landingPageUrl"
            :href="getLandingPageUrl()"
            class="transition-ease-in-out m-px block w-1/2 bg-white px-4 py-5 text-center text-sm font-medium uppercase leading-snug text-primary-main hover:text-primary-light"
          >
            <span>{{ $t("layouts.patient") }}</span>
          </a>
          <a
            v-if="landingPageUrl"
            :href="getLandingPageUrl('doctor')"
            class="transition-ease-in-out m-px block w-1/2 bg-[#f9f9fc] px-4 py-5 text-center text-sm font-medium uppercase leading-snug text-primary-main hover:text-primary-light"
          >
            <span>{{ $t("layouts.doctor") }}</span>
          </a>
        </div>

        <a
          :href="getLandingPageUrl('lab-test-list/tests')"
          class="transition-ease-in-out mb-px block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-primary-main hover:text-primary-light"
        >
          <span>{{ $t("layouts.catalog") }}</span>
        </a>

        <a
          :href="getLandingPageUrl('locations')"
          class="transition-ease-in-out mb-px block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-primary-main hover:text-primary-light"
        >
          <span>{{ $t("layouts.collection_points") }}</span>
        </a>

        <router-link
          :to="{ name: 'Results' }"
          class="transition-ease-in-out mb-px block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-primary-main hover:text-primary-light"
          @click="closeMenu"
        >
          <span>{{ $t("layouts.receive_results") }}</span>
        </router-link>

        <router-link
          :to="{ name: 'WeightLossProgress' }"
          class="transition-ease-in-out mb-px block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-primary-main hover:text-primary-light"
          @click="closeMenu"
        >
          <span>{{ $t("layouts.weight_loss") }}</span>
        </router-link>

        <a
          :href="
            isEnabledFeature('new_offers_page')
              ? getLandingPageUrl('offers')
              : getLandingPageUrl(
                  'offer/invest-in-the-health-of-your-workforce-today'
                )
          "
          class="transition-ease-in-out mb-px block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-primary-main hover:text-primary-light"
        >
          {{ $t("layouts.offer") }}
        </a>

        <a
          :href="`${landingPageUrl}/news/getlabtest-news`"
          class="transition-ease-in-out mb-px block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-primary-main hover:text-primary-light"
        >
          Blog
        </a>

        <div
          class="transition-ease-in-out block w-full bg-white text-left text-sm font-medium leading-snug text-primary-main hover:text-primary-light"
        ></div>
      </div>
    </transition>
  </div>
</template>

<script>
import landingPageMixin from "@/mixins/landingPageMixin";
import { mapGetters } from "vuex";

export default {
  name: "LayoutsUserDropdownNavigation",
  mixins: [landingPageMixin],
  data() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      isEnabledFeature: "features/isEnabled",
    }),
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.router-link-active {
  @apply text-accent;
}
</style>
